import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import style from './LastUpdated.scss';

const propTypes = {
  lastPublished: PropTypes.string,
  live: PropTypes.bool.isRequired,
  // lastUpdated will be required once all versions have saved their createdAt timestamps
  lastUpdated: PropTypes.string,
};

const defaultProps = {
  lastPublished: false,
};

// some of this logic can be removed once all versions have createdAt
const LastUpdated = ({ lastPublished, lastUpdated, live }) => {
  const zone = moment().tz(moment.tz.guess()).format('z');
  const updated = lastUpdated ? moment(lastUpdated).local() : null;
  const published = lastPublished ? moment(lastPublished).local() : null;
  const backupPublishedText = !published && live ? 'published before 06/15/2018' : 'never published';

  const publishedText = published ?
    `published ${published.format('MM/DD/YYYY [at] hh:mm a')} ${zone}` : backupPublishedText;
  const updatedText = updated ? `${updated.format('MM/DD/YYYY [at] hh:mm a')} ${zone}` : null;

  return (
    <div>
      <div>
        {updatedText}
      </div>
      <div className={style.publishedText}>
        {publishedText}
      </div>
    </div>
  );
};

LastUpdated.propTypes = propTypes;
LastUpdated.defaultProps = defaultProps;

export default LastUpdated;
